import { useDispatch, useSelector } from "react-redux";
import {
  setStats,
  clearStats,
} from "../../store/slices/dashboard/supplierDashboardSlice";
import { AppDispatch, RootState } from "../../store/store";
import SupplierDashboardService from "../../services/dashboard/SupplierDashboardService";
import useApiErrorHandler from "../useApiErrorHandler";
// import useLoading from "../useLoading";

export const useSupplierDashboard = () => {
  const dispatch: AppDispatch = useDispatch();
  const { handle } = useApiErrorHandler();
  // const { showLoadingIndicator, hideLoadingIndicator } = useLoading();

  // ✅ Estado desde Redux
  const { stats } = useSelector(
    (state: RootState) => state.supplierDashboard
  );

  /**
   * 📊 Cargar estadísticas del dashboard de proveedores
   */
  const fetchStats = async () => {
    try {
      // showLoadingIndicator();

      const response = await SupplierDashboardService.getStats();
      if (response?.statusCode === 200) {
        const { data } = response;
        dispatch(setStats(data));
        // 🚫 Eliminado: openModal
      }
    } catch (error: any) {
      handle(error);
    } finally {
      // hideLoadingIndicator();
    }
  };

  /**
   * 🔄 Limpiar estadísticas (si necesitas resetear en algún momento)
   */
  const resetStats = () => {
    dispatch(clearStats());
  };

  return {
    // 📌 Estados
    stats,

    // 📌 Métodos
    fetchStats,
    resetStats,
  };
};

export default useSupplierDashboard;
